import { cn } from "../../utils/classnames.js";
import { jsx } from "react/jsx-runtime";
import { NavigationMenu } from "@base-ui/react/navigation-menu";
//#region src/components/atoms/navigation-menu.tsx
const NavigationMenuList = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.List, {
		"data-slot": "navigation-menu-list",
		className: cn(`group gap-1 lg:gap-2 xl:gap-3 flex flex-1 list-none items-center justify-center`, className),
		...props
	});
};
const NavigationMenuItem = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.Item, {
		"data-slot": "navigation-menu-item",
		className: cn("relative text-nowrap", className),
		...props
	});
};
const NavigationMenuContent = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.Content, {
		"data-slot": "navigation-menu-content",
		className: cn(`
          data-[motion^=from-]:animate-in
          data-[motion^=to-]:animate-out
          data-[motion^=from-]:fade-in
          data-[motion^=to-]:fade-out
          data-[motion=from-end]:slide-in-from-right-52
          data-[motion=from-start]:slide-in-from-left-52
          data-[motion=to-end]:slide-out-to-right-52
          data-[motion=to-start]:slide-out-to-left-52
          p-2 pr-2.5
          md:w-auto
          w-full
        `, `
          group-data-[viewport=false]/navigation-menu:bg-popover
          group-data-[viewport=false]/navigation-menu:text-popover-foreground
          group-data-[viewport=false]/navigation-menu:rounded-md
          group-data-[viewport=false]/navigation-menu:shadow-sm
          group-data-[viewport=false]/navigation-menu:data-open:animate-in
          group-data-[viewport=false]/navigation-menu:data-closed:animate-out
          group-data-[viewport=false]/navigation-menu:data-closed:zoom-out-95
          group-data-[viewport=false]/navigation-menu:data-open:zoom-in-95
          group-data-[viewport=false]/navigation-menu:data-open:fade-in-0
          group-data-[viewport=false]/navigation-menu:data-closed:fade-out-0
          group-data-[viewport=false]/navigation-menu:top-full
          group-data-[viewport=false]/navigation-menu:overflow-hidden
          group-data-[viewport=false]/navigation-menu:border
          group-data-[viewport=false]/navigation-menu:duration-200
          **:data-[slot=navigation-menu-link]:focus:ring-0
          **:data-[slot=navigation-menu-link]:focus:outline-none
        `, className),
		...props
	});
};
const NavigationMenuPositioner = ({ className, side = "bottom", sideOffset = 8, align = "start", alignOffset = 0, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.Portal, { children: /* @__PURE__ */ jsx(NavigationMenu.Positioner, {
		side,
		sideOffset,
		align,
		alignOffset,
		className: cn(`
            isolate z-50 transition-[top,left,right,bottom] duration-[0.35s]
            ease-[cubic-bezier(0.22,1,0.36,1)]
          `, className),
		...props,
		children: /* @__PURE__ */ jsx(NavigationMenu.Popup, {
			className: cn(`
            rounded-md bg-popover text-popover-foreground shadow-sm ring-foreground/10 relative
            origin-[--transform-origin] ring-1 transition-[opacity,width,height,transform]
            duration-[0.35s] ease-[cubic-bezier(0.22,1,0.36,1)] outline-none
            data-ending-style:scale-90 data-ending-style:opacity-0 data-ending-style:duration-150
            data-starting-style:scale-90 data-starting-style:opacity-0
          `),
			children: /* @__PURE__ */ jsx(NavigationMenu.Viewport, { className: "relative size-full overflow-hidden" })
		})
	}) });
};
const NavigationMenuLink = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.Link, {
		"data-slot": "navigation-menu-link",
		className: cn(`
          hover:text-primary-text
          focus-visible:text-primary-text
          font-medium gap-1 rounded-md p-2
          focus-visible:ring-ring/90
          [&_svg:not-[class*='text-']]:text-muted-foreground
          [&_svg:not-[class*='size-']]:size-4
          data-active:text-primary-text/90
          focus-visible:outline-ring
          flex h-full flex-col transition-all duration-200 outline-none
          hover:scale-105
          focus-visible:scale-105 focus-visible:ring-3 focus-visible:outline-2
        `, className),
		...props
	});
};
const NavigationMenuIndicator = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(NavigationMenu.Icon, {
		"data-slot": "navigation-menu-indicator",
		className: cn(`
          data-[state=visible]:animate-in
          data-[state=hidden]:animate-out data-[state=hidden]:fade-out
          data-[state=visible]:fade-in
          h-1.5 top-full z-1 flex items-end justify-center overflow-hidden
        `, className),
		...props,
		children: /* @__PURE__ */ jsx("div", { className: "bg-border size-2 rounded-tl-sm shadow-md relative top-[60%] rotate-45" })
	});
};
//#endregion
export { NavigationMenuContent, NavigationMenuIndicator, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuPositioner };

//# sourceMappingURL=navigation-menu.js.map